const messages = {
	GET_OTP: 'OTP send successfully',
	VALID: 'Please enter valid number',
	LOGIN: 'Login successfully',
	VALID_ID: 'Please enter valid login ID',
	VALID_ACCO: 'Please enter valid Account No.',
	VALID_IFSC: 'Please enter valid IFSC Code',
	ENTER_ACCO: 'Please enter Account No.',
	ENTER_IFSC: 'Please enter IFSC Code',
};

export default messages;